import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosEligibleFuneralHomesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosEligibleFuneralHomesController.php
* @route '/api/funeral-home/enaos-eligible'
*/
const EnaosEligibleFuneralHomesController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: EnaosEligibleFuneralHomesController.url(options),
    method: 'get',
})

EnaosEligibleFuneralHomesController.definition = {
    methods: ["get","head"],
    url: '/api/funeral-home/enaos-eligible',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosEligibleFuneralHomesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosEligibleFuneralHomesController.php
* @route '/api/funeral-home/enaos-eligible'
*/
EnaosEligibleFuneralHomesController.url = (options?: RouteQueryOptions) => {
    return EnaosEligibleFuneralHomesController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosEligibleFuneralHomesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosEligibleFuneralHomesController.php
* @route '/api/funeral-home/enaos-eligible'
*/
EnaosEligibleFuneralHomesController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: EnaosEligibleFuneralHomesController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosEligibleFuneralHomesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosEligibleFuneralHomesController.php
* @route '/api/funeral-home/enaos-eligible'
*/
EnaosEligibleFuneralHomesController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: EnaosEligibleFuneralHomesController.url(options),
    method: 'head',
})

export default EnaosEligibleFuneralHomesController